import { render, staticRenderFns } from "./ShippingHistoryList.html?vue&type=template&id=36e4147e&external"
import script from "./ShippingHistoryList.ts?vue&type=script&lang=ts&external"
export * from "./ShippingHistoryList.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingHistoryList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports